/**
 * App — the ROUTER.
 *
 * Two kinds of routes:
 *   1. Pages INSIDE CustomerLayout — they get the orange search navbar, footer,
 *      floating cart bar and bottom nav (Home, Categories, Search, Profile…).
 *   2. STANDALONE pages — Product detail and Cart. These render their OWN
 *      minimal headers (no orange search navbar), because the reference design
 *      — and your request — call for a focused, chrome-free view there.
 *
 * The 404 route is also standalone.
 */

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { CustomerLayout } from '@/components/layout/CustomerLayout';
import { HomePage } from '@/pages/HomePage';
import { CategoriesPage } from '@/pages/CategoriesPage';
import { SearchPage } from '@/pages/SearchPage';
import { ProductDetailPage } from '@/pages/ProductDetailPage';
import { CartPage } from '@/pages/CartPage';
import { CheckoutPage } from '@/pages/CheckoutPage';
import { OrdersPage } from '@/pages/OrdersPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { ProfileDetailsPage } from '@/pages/ProfileDetailsPage';
import { AddressPage } from '@/pages/AddressPage';
import { HelpPage } from '@/pages/HelpPage';
import { LoginPage } from '@/pages/LoginPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { RequireAuth } from '@/components/RequireAuth';

const router = createBrowserRouter([
  {
    // Pages with the full storefront chrome.
    path: '/',
    element: (
      <RequireAuth>
        <CustomerLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <HomePage /> },
      { path: 'categories', element: <CategoriesPage /> },
      { path: 'categories/:slug', element: <CategoriesPage /> },
      { path: 'search', element: <SearchPage /> },
      { path: 'orders', element: <OrdersPage /> },
      { path: 'profile', element: <ProfilePage /> },
      { path: 'profile-details', element: <ProfileDetailsPage /> },
      { path: 'addresses', element: <AddressPage /> },
      { path: 'help', element: <HelpPage /> },
    ],
  },

  // Standalone — own minimal header, no orange search navbar.
  { path: '/login', element: <LoginPage /> },
  { path: '/product/:slug', element: (
      <RequireAuth>
        <ProductDetailPage />
      </RequireAuth>
    ),
  },
  { path: '/cart', element: (
      <RequireAuth>
        <CartPage />
      </RequireAuth>
    ),
  },
  { path: '/checkout', element: (
      <RequireAuth>
        <CheckoutPage />
      </RequireAuth>
    ),
  },

  { path: '*', element: <NotFoundPage /> },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
